import React from "react";
import CodeSnippetManager from "../CodeSnippetManager";
import "./RenderFields.css";


const RenderFields = ({ data, parentKey = "", form, onChange }) => {
    const getValue = (obj, path) => {
        return path.split('.').reduce((acc, key) => {
            if (acc && acc.hasOwnProperty(key)) {
                return acc[key];
            }
            return null;
        }, obj);
    };

    const updateField = (e) => {
        const { name, type, value, checked } = e.target;
        const keys = name.split(".");

        onChange((prev) => {
            const newForm = structuredClone(prev);
            let curr = newForm;

            keys.forEach((k, i) => {
                if (curr[k] === undefined) curr[k] = {};

                if (i === keys.length - 1) {
                    curr[k] = type === "checkbox" ? checked : value;
                } else {
                    curr = curr[k];
                }
            });

            return newForm;
        });
    };

    return (
        <>
            {Object.entries(data).map(([key, value]) => {
                const fullKey = parentKey ? `${parentKey}.${key}` : key;

                // Handle arrays (for gtmCodes, fbPixelCodes, etc.)
                if (Array.isArray(value)) {
                    // Check if it's a code array
                    if (key.toLowerCase().includes('code')) {
                        return (
                            <div key={fullKey} className="mb-3">
                                <CodeSnippetManager
                                    label={key.replace(/([A-Z])/g, ' $1').trim()}
                                    snippets={getValue(form, fullKey) ?? value}
                                    onChange={(newSnippets) => {
                                        const keys = fullKey.split(".");
                                        onChange((prev) => {
                                            const newForm = structuredClone(prev);
                                            let curr = newForm;
                                            keys.forEach((k, i) => {
                                                if (i === keys.length - 1) {
                                                    curr[k] = newSnippets;
                                                } else {
                                                    if (curr[k] === undefined) curr[k] = {};
                                                    curr = curr[k];
                                                }
                                            });
                                            return newForm;
                                        });
                                    }}
                                />
                            </div>
                        );
                    }
                    // For other arrays, just show a note (can be extended later)
                    return (
                        <div key={fullKey} className="mb-3">
                            <label className="form-label">{key}</label>
                            <div className="text-muted small">Array field (not editable in this view)</div>
                        </div>
                    );
                }

                if (typeof value === "object" && value !== null && !Array.isArray(value)) {
                    return (
                        <div key={fullKey} className="mb-3 border rounded p-3">
                            <div className="fw-bold mb-2 text-capitalize">{key === 'download' ? 'Brochure Image' : key}</div>

                            <RenderFields
                                data={value}
                                parentKey={fullKey}
                                form={form}
                                onChange={onChange}
                            />
                        </div>
                    );
                }

                if (typeof value === "boolean") {
                    return (
                        <div key={fullKey} className="form-check mb-2">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id={fullKey}
                                name={fullKey}
                                checked={getValue(form, fullKey) ?? getValue(data, fullKey)}
                                onChange={(e) => updateField(e)(e)}
                            />
                            <label className="form-check-label">{key}</label>
                        </div>
                    );
                }

                return (
                    <div key={fullKey} className="mb-2">
                        <label className="form-label" htmlFor={fullKey}>{key}</label>
                        {key.toLowerCase().includes('code') || key.toLowerCase().includes('message') || key.toLowerCase().includes('des') ? (
                            <textarea
                                className="form-control"
                                id={fullKey}
                                name={fullKey}
                                rows={4}
                                value={getValue(form, fullKey) ?? getValue(data, fullKey)}
                                onChange={(e) => updateField(e)}
                            />
                        ) : (
                            <input
                                type={typeof value === "number" ? "number" : "text"}
                                className="form-control"
                                id={fullKey}
                                name={fullKey}
                                value={getValue(form, fullKey) ?? getValue(data, fullKey)}
                                onChange={(e) => updateField(e)}
                            />
                        )}
                    </div>
                );
            })}
        </>
    );
};
export default React.memo(RenderFields);